import React from "react";
import { ConfigProvider } from "antd";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import "./theme.css";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#145a3d",
          borderRadius: 18,
          fontFamily: "Inter, Arial, sans-serif",
        },
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;